<template>
  <div class="notice">
    <!-- <div class="big"> -->
      <!-- <span v-if="!distanceTime">2023世界人工智能大会敬请期待</span> -->
      <!-- <i18n path="distanceTime" tag="div">
          <span place="num" class="day-num">{{ distanceTime }}</span>
        </i18n>
    </div> -->
    <div class="big" v-if="!En"><span>{{ pageTime['首页-往届回顾上面文案'] }}</span></div>
    <div class="small">{{ pageTime['首页-往届回顾上面文案-en'] }}</div>
    <div class="btn" @click="link(data[0])" :style="{ width: En ? '2.6rem' : '2rem' }">{{ $t('pastReview') }}</div>
    <div class="links">
      <span v-for="(item, index) in data" :key="index" :href="item.href" @click="link(item, index + 1)">{{ item }}</span>
    </div>
  </div>
</template>

<script>
import protal from "@/api/protal";

export default {
  name: 'notice',
  data() {
    return {
      data: [],
      distanceTime: ''
    }
  },
  created() {
    this.getDisTime();
    this.init()
  },
  methods: {
    link(name, index) {
      this.$jsAPI('track','homeClick',
          {
            'floor_var': '大会倒计时banner',
            'position_var': index ? index + '' : '按钮',
            'flowName_var': index ? name : this.$t('pastReview'),
            'industryFirstCate_var': '无',
            'industrySecCate_var': '无',
            'tabName_var': `无`,
          }
      );
      gio('track','homeClick',
          {
            'floor_var': '大会倒计时banner',
            'position_var': index ? index + '' : '按钮',
            'flowName_var': index ? name : this.$t('pastReview'),
            'industryCate_var': '无',
            'industryFirstCate_var': '无',
            'tabName_var': `无`,
          }
      );

      this.$router.push('/wangjie?year=' + name)
    },
    init() {
      protal.getZdType('previous_year').then(res => {
        const times = res.data || []
        this.data = times.filter(x => x.lableValue !== 'hide').map(x => x.lableDesc)
      })
    },
    getDisTime() {
      protal.queryDistanceTimeNum().then((res) => {
        this.distanceTime = (res && res.data) || 0;
      });
    },
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .notice {
    position: absolute;
    left: 0;
    top: 12.7rem;
    width: 100%;
    text-align: center;
    z-index: 2;

    .big {
      & > div {
        height: .48rem;
        font-size: .48rem;
        font-family: sybold;
        font-weight: 500;
        color: #595757;
        line-height: 1;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        letter-spacing: 0.04rem;
      }

      span {
        font-size: .5rem;
        color: rgba(47, 159, 250, 1);
        letter-spacing: .08rem;
        position: relative;
        top: .04rem;
      }
    }

    .small {
      font-size: .22rem;
      font-family: sybold;
      font-weight: 500;
      color: #284599;
      line-height: 1;
      letter-spacing: .07rem;
      margin: .24rem 0 .64rem;
    }

    .btn {
      width: 2rem;
      height: .64rem;
      background: #2F9FFA;
      border-radius: .32rem;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: .26rem;
      line-height: 1;
      color: #fff;
      cursor: pointer;
    }

    .links {
      margin-top: .32rem;
      display: flex;
      justify-content: center;

      span {
        color: rgba(75, 172, 250, 0.3);
        font-size: .28rem;
        font-weight: 800;
        line-height: 1;
        margin: 0 .37rem;
        transition: .5s;
        cursor: pointer;
        text-decoration: underline;

        &:hover {
          color: rgba(75, 172, 250, 1);
        }
      }
    }
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .notice {
    width: 100%;
    text-align: center;
    z-index: 2;
    background: linear-gradient(45deg, RGBA(212, 220, 226, 1) 0%, RGBA(225, 223, 217, 1) 100%);
    overflow: hidden;
    padding-top: .2rem;

    .big {
      & > div {
        height: .34rem;
        font-size: .34rem;
        font-weight: 500;
        color: #595757;
        line-height: 1;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        font-family: sybold;
      }

      span {
        font-size: .56rem;
        color: rgba(47, 159, 250, 1);
        line-height: 1;
        position: relative;
        top: .04rem;
      }
    }

    .small {
      font-size: .2rem;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #284599;
      line-height: 1;
      letter-spacing: .05rem;
      margin: .22rem 0 .44rem;
      white-space: nowrap;
    }

    .btn {
      width: 1.88rem;
      height: .72rem;
      background: #2F9FFA;
      border-radius: .36rem;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: .28rem;
      line-height: 1;
      color: #fff;
      cursor: pointer;
    }

    .links {
      margin-top: .36rem;
      padding-bottom: .84rem;
      display: flex;
      justify-content: center;

      span {
        color: rgba(75, 172, 250, 0.3);
        font-size: .28rem;
        font-weight: 800;
        line-height: 1;
        margin: 0 .37rem;
        text-decoration: underline;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/notice.vue